/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Confirm_PlainInputs */



/**
* | output |
* | --- |
* | "Enable billing" |
*
* @param {Partner_Admin_Billing_Confirm_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_confirm_plain = /** @type {((inputs?: Partner_Admin_Billing_Confirm_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Confirm_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnung aktivieren")
	return /** @type {LocalizedString} */ ("Enable billing")
});